import React from 'react';
import { Alert, Typography } from '@mui/material';

interface CallerInfoAlertProps {
  callerName: string | undefined;
}

export const CallerInfoAlert: React.FC<CallerInfoAlertProps> = ({ callerName }) => {
  return (
    <Alert
      severity="info"
      sx={{
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        '& .MuiAlert-icon': { color: '#0284c7' }
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Call logged by: {callerName || 'Loading...'}
      </Typography>
    </Alert>
  );
};
